import { render, staticRenderFns } from "./mcrButtonRouterLink.vue?vue&type=template&id=3da80772&scoped=true"
import script from "./mcrButtonRouterLink.vue?vue&type=script&lang=js"
export * from "./mcrButtonRouterLink.vue?vue&type=script&lang=js"
import style0 from "./mcrButtonRouterLink.vue?vue&type=style&index=0&id=3da80772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da80772",
  null
  
)

export default component.exports